import { ChangeDetectionStrategy, Component, input, output } from '@angular/core'
import { ListCsvExportButtonComponent } from '../list-csv-export-button/list-csv-export-button.component'

@Component({
	selector: 'app-list-results-bar',
	standalone: true,
	imports: [ListCsvExportButtonComponent],
	templateUrl: './list-results-bar.component.html',
	styleUrl: './list-results-bar.component.scss',
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ListResultsBarComponent {
	readonly resultsLabel = input.required<string>()
	readonly downloadDisabled = input(false)
	readonly downloadLabel = input('Descargar CSV')
	readonly downloadTooltip = input('Descargar CSV')
	readonly showDownload = input(true)

	readonly downloadClicked = output<void>()
}
